import React from 'react'
import Table from 'react-bootstrap/Table'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'

function ManagedProduct() {
  return (
        <div className="mainContainer">
            <LeftBar />
            <div className="theMainContainer">
                <Dashnav />
                <div className='clientsComp'>
                    <div className="dataCompTop">
                        <h5>Managed Product</h5>
                        <div className="searchContainer">
                        </div>
                    </div>


                    {/* <div className="table-responsive">
                        <table className="table table-bordered table-striped align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>Student's Name</th>
                                    <th>Course</th>
                                    <th>Application Date</th>
                                    <th>Country</th>
                                    <th>Video Call Date</th>
                                    <th>Call Status</th>
                                    <th>Join</th>
                                </tr>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </div> */}


                </div>

            </div>
        </div>
    )
}

export default ManagedProduct